import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductShowcase from './components/ProductShowcase';
import CaseStudies from './components/CaseStudies';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import GoogleAdsLanding from './components/landings/GoogleAdsLanding';
import LinkedInLanding from './components/landings/LinkedInLanding';
import FacebookLanding from './components/landings/FacebookLanding';
import YouTubeLanding from './components/landings/YouTubeLanding';
import TikTokLanding from './components/landings/TikTokLanding';
import GenericLanding from './components/landings/GenericLanding';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Routes>
          <Route path="/" element={
            <>
              <Navbar />
              <Hero />
              <AboutUs />
              <ProductShowcase />
              <CaseStudies />
              <Pricing />
              <Contact />
              <Footer />
            </>
          } />
          <Route path="/google-ads" element={<GoogleAdsLanding />} />
          <Route path="/linkedin" element={<LinkedInLanding />} />
          <Route path="/facebook" element={<FacebookLanding />} />
          <Route path="/youtube" element={<YouTubeLanding />} />
          <Route path="/tiktok" element={<TikTokLanding />} />
          <Route path="/start" element={<GenericLanding />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;